export default __webpack_public_path__ + "static/media/clouds_container.eb0190b2.svg";